import React, { useState, useEffect } from "react";
import { Tabs, Breadcrumb, Tooltip, Badge, Card, Form } from "antd";
import { useLocation, Link, useNavigate } from "react-router-dom";
import EndpointDetailsUser from "./EndpointDetailsUser";
import EndpointDetailsGroup from "./EndpointDetailsGroup";
import EndpointDetailsServices from "./EndpointDetailsServices";
import moment from "moment-timezone";
import { Globe, Home } from "lucide-react";
import { CustomTagRender } from "../../../../utils/helpers";
import { AppContentLayout } from "../../../../layout/applayout";

const EndpointDetails = ({ selectedEndpoints }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  // const hostAddress = queryParams.get("hostAddress");
  const isTabChange = queryParams.get("tab");
  const defaultTab = queryParams.get("defaultTab");
  const [selectedTab, setSelectedTab] = useState("1");
  const navigate = useNavigate();
  // const { hostAddress } = location.state || {};
  const endPoints = JSON.parse(localStorage.getItem("endPoints")) || {};
  const { hostName } = endPoints;
  const { hostName: hostAddress } = endPoints;
  useEffect(() => {
    handleQueryParam();
  }, []);

  const Storage = localStorage.getItem("details");
  const stateHostAddress = JSON.parse(Storage);

  const items = [
    {
      key: "1",
      label: "Endpoint User",
      children: <EndpointDetailsUser stateHostAddress={stateHostAddress} />,
    },
    {
      key: "2",
      label: "Local User Group",
      children: <EndpointDetailsGroup stateHostAddress={stateHostAddress} />,
    },
    // {
    //   key: "3",
    //   label: "Auth Flow",
    //   children: <EndpointDetailsAuthFlow stateHostAddress={stateHostAddress} />,
    // },
    {
      key: "4",
      label: "Services",
      children: <EndpointDetailsServices />,
    },
  ];

  const handleTab = (key) => {
    setSelectedTab(key);
  };
  const handleQueryParam = (key) => {
    if (defaultTab === "hostname") {
      setSelectedTab("1");
    } else if (defaultTab === "usercount") {
      setSelectedTab("1");
      console.log(defaultTab);
    } else if (defaultTab === "groupcount") {
      setSelectedTab("2");
      console.log(defaultTab);
    }
  };

  return (
    <>
      <AppContentLayout
        title={
          <div className="bg-white border-b px-4 py-4">
            <Breadcrumb
              items={[
                {
                  title: (
                    <>
                      <Link className="!flex items-center" to="/tenant/dashboard">
                        <Home className="!size-4" />
                      </Link>
                    </>
                  ),
                },
                {
                  title: (
                    <Link onClick={() => navigate(-1)} className="!flex items-center cursor-pointer space-x-1">
                      <Globe className="!size-4" />
                      <span>Endpoints</span>
                    </Link>
                  ),
                },
                {
                  title: "Endpoint Details",
                },
              ]}
            />
          </div>
        }
        cardChildren={
          <div className="space-y-2">
            <div>
              <h2 className="text-lg font-semibold">
                Endpoint Details - <span style={{ color: "rgb(22, 119, 255)", cursor: "pointer" }} onClick={() => navigate(-1)}>{`${hostAddress ? hostAddress : stateHostAddress.hostAddress}`}</span>
              </h2>
            </div>
            <InstanceSummaryCard hostAddress={hostAddress} endPoints={endPoints} />
            <Tabs activeKey={selectedTab} onChange={handleTab} items={items} />
          </div>
        }
      />
    </>
  );
};

export default EndpointDetails;

function InstanceSummaryCard({ endPoints }) {
  const { hostName, description: descProp, privateIp, publicIp, fqdn, status, lastActive, osname, instanceId } = endPoints || {};
  const [form] = Form.useForm();
  const EndpointStatus = (lastUpdated) => {
    const timezone = localStorage.getItem("timezone");
    const lastActive = moment.unix(lastUpdated).tz(timezone).format("YYYY-MM-DD HH:mm:ss");
    const diff = moment().diff(lastActive, "minutes");
    let hours = Math.floor(diff / 60);
    let days = Math.floor(hours / 24);
    let minutes = diff % 60;

    let message;
    if (days > 0) {
      message = `Last Active: ${days} days ago`;
    } else if (hours > 0) {
      message = `Last Active: ${hours} hours${minutes > 0 ? ` and ${minutes} minutes ago` : ""}`;
    } else {
      message = `Last Active: ${diff} minutes ago`;
    }

    if (diff > 20) {
      return (
        <Tooltip title={message}>
          <Badge status="error" text="Offline" />
        </Tooltip>
      );
    } else if (diff > 10) {
      return (
        <Tooltip title={message}>
          <Badge status="warning" text="Offline" />
        </Tooltip>
      );
    }
    return <Badge status="success" text="Online" />;
  };

  const osLabel = osname ? osname.charAt(0).toUpperCase() + osname.slice(1) : "-";

  // handle update
  return (
    <Card
      bordered
      className="rounded-sm shadow pt-0"
      styles={{
        body: {
          padding: 10,
        },
        header: {
          padding: 0, // removes header padding
        },
      }}
    >
      <table className="w-full border-collapse">
        <tbody>
          <tr>
            <td className="w-1/3 font-semibold p-2">Host Name</td>
            <td className="w-2/3 p-2">{hostName || "-"}</td>
          </tr>
          <tr>
            <td className="w-1/3 font-semibold p-2">Description</td>
            <td className="w-2/3 p-2">
              <div className="inline-flex items-center  gap-2">
                <span className="whitespace-pre-wrap break-words text-gray-700">{descProp || "-"}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td className="w-1/3 font-semibold p-2">OS</td>
            <td className="w-2/3 p-2">{osLabel || "-"}</td>
          </tr>
          {/* PUBLIC IP */}
          <tr>
            <td className="w-1/3 font-semibold p-2">Public IP</td>
            <td className="w-2/3 p-2">
              <div className="flex items-center gap-2">
                <span className=" text-gray-700">{publicIp || "-"}</span>
              </div>
            </td>
          </tr>
          {/* PRIVATE IP */}
          <tr>
            <td className="w-1/3 font-semibold p-2">Private IP</td>
            <td className="w-2/3 p-2">
              <div className="flex items-center gap-2">
                <span className=" text-gray-700">{privateIp || "-"}</span>
              </div>
            </td>
          </tr>
          {/* FQDN */}
          <tr>
            <td className="w-1/3 font-semibold p-2">FQDN</td>
            <td className="w-2/3 p-2">
              <div className="inline-flex items-center gap-2">
                <span className="text-gray-700">{fqdn || "-"}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td className="w-1/3 font-semibold p-2">Status</td>
            <td className="w-2/3 p-2">
              <CustomTagRender isCap={true} color={status?.toLowerCase() === "active" ? "green" : "red"} value={status?.toLowerCase() || "-"} />
            </td>
          </tr>
          <tr>
            <td className="w-1/3 font-semibold p-2">Agent Status</td>
            <td className="w-2/3 p-2">{EndpointStatus(lastActive)}</td>
          </tr>
        </tbody>
      </table>
    </Card>
  );
}
